/*
 * PREFERENCE SELECTORS - getting data out of the preference store
 *
 * These routines require a "state" value from the preference store, to access
 * the data model from anywhere,use the preferenceStore module which will create the
 * state then call these routines
 */

import { getSharedPreferencesByPath } from 'companion-app-components/flux/preferences/selectors';

// plain accessors (not createSelector): each just reads a single path with no transformation,
// so memoizing would only trigger reselect's identity-function dev warning for no benefit
export const isCompareToRegisterEnabled = (state) =>
  getSharedPreferencesByPath(state, { group: 'dataset', path: ['compareToRegister', 'enabled'] });

export const getRunningBalanceExcludeAccountIds = (state) =>
  getSharedPreferencesByPath(state, { group: 'dataset', path: ['excludePendingInRunningBalance'] });

export const isApplyMemorizedRulesEnabled = (state) =>
  getSharedPreferencesByPath(state, { group: 'dataset', path: ['transactionOptions', 'applyMemorizedRules'] });

export const isCreateMemorizedRulesEnabled = (state) =>
  getSharedPreferencesByPath(state, { group: 'dataset', path: ['transactionOptions', 'autoCreateMemorizedRule'] });
